var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('style',{tag:"component",attrs:{"type":"text/css","scoped":""},domProps:{"innerHTML":_vm._s(_vm.purifiedCss)}})
}
var staticRenderFns = []

export { render, staticRenderFns }